module.exports = "<div class=help-button hm-tap=$ctrl.ScreenManager.openHelp()> <div class=icon-help></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/help-button/help-button.html
 ** module id = 59
 ** module chunks = 0
 **/